/**
 * 絞り込み・検索・対象期間・操作を並べる行(設計書 §5-1。最低 48px)。業務ロジックは持たない。
 *  - children: いつも出す条件(在籍・検索など)
 *  - more: PCでは並べて出し、スマホ(≤900px)では「その他の条件」ボタンで開閉する条件(設計書 §6 絞り込みパネル)
 *  - moreActiveCount: more の中で絞り込み中の数(ボタンに「(2)」と出す。数えるのは画面側)
 */
import { useId, useState, type ReactNode } from 'react';
import { IconChevronDown } from '@core/components/icons';

export default function FilterBar({
  children,
  more,
  moreActiveCount = 0,
  actions,
  label = '絞り込み',
}: {
  children: ReactNode;
  more?: ReactNode;
  moreActiveCount?: number;
  actions?: ReactNode;
  label?: string;
}) {
  const [open, setOpen] = useState(false);
  const moreId = useId();
  return (
    <div className={`filter-bar${open ? ' is-more-open' : ''}`} role="group" aria-label={label}>
      <div className="filter-bar-fields">
        {children}
        {more && (
          <>
            <button type="button" className="ui-btn ui-btn-secondary filter-bar-more-toggle" aria-expanded={open} aria-controls={moreId} onClick={() => setOpen((v) => !v)}>
              その他の条件{moreActiveCount > 0 ? `(${moreActiveCount})` : ''}
              <IconChevronDown size={14} />
            </button>
            <div id={moreId} className="filter-bar-more">
              {more}
            </div>
          </>
        )}
      </div>
      {actions && <div className="filter-bar-actions">{actions}</div>}
    </div>
  );
}
